// TippyJs Plugin setup
import tippy from 'tippy.js'

/**
 * Create tippy
 *
 * Custom global function to create the required instance.
 *
 * @param { HTML Element } trigger The element witch will toggle visbility.
 * @param { HTML Element } template The content to render inside the popper.
 * @param { Object } options Configurations props. See → https://atomiks.github.io/tippyjs/v6/all-props/
 *
 * @returns { Object } Tippy instance to be save in a variable.
 *                     See → https://atomiks.github.io/tippyjs/v6/tippy-instance/
 */
const createTippy = (trigger, template, options) => {
  return tippy(trigger, {
    content: template,
    ...options,
  })
}

export { createTippy }
